<template>
  <div class="content-body chat-container chat-table">
    <div class="table-chat chat">
      <ul :id="'group-' + group.uuid + '-messages'" class="stream list-group list-group-flush" ref="messagesTable">
        <li class="message-item">
          <div class="msg-container info-message">
            <div class="chat-help">
              <div class="help-ico"><i class="fa fa-info-circle" aria-hidden="true"></i></div>
              <div class="help-info">
                <ul>
                  <li>
                    Here you can chat privately to the other guests at your
                    {{ groupTerminology.toLowerCase() }}
                  </li>
                  <li>
                    You can see who's at you {{ groupTerminology.toLowerCase() }} via
                    <a
                      href="javascript:void(0);"
                      class="nodecoration"
                      @click="openTabs(['#tab-people', '#tab-people-table'])"
                      >People > My {{ groupTerminology }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        <li v-if="canLoadMoreMessages" class="text-center">
          <a href="javascript:void(0);" class="msg-load-more" @click="loadMoreMessages"
            ><i class="fa fa-chevron-up" aria-hidden="true"></i><span> read more </span
            ><i class="fa fa-chevron-up" aria-hidden="true"></i
          ></a>
        </li>
        <chat-message
          v-for="(message, index) in exposedMessages"
          :key="'tableMessage-' + index"
          :message="message"
          type="TABLE"
        ></chat-message>
      </ul>

      <div :id="group.uuid + '-new-message'" class="message-new">
        <chat-input
          v-model="message"
          :placeholder="'private message to my ' + groupTerminology.toLowerCase() + ' ...'"
          :group="group"
          @send-message="sendMessage()"
          @emoji-picked="emojiPicked($event)"
        ></chat-input>
      </div>
    </div>
  </div>
</template>

<script>
import ChatMixin from "@/components/DigitalEvent/RoomList/Room/mixins/ChatMixin";
import ChatInput from "@/components/DigitalEvent/RoomList/Room/Chat/components/ChatInput";
import { mapGetters } from "vuex";
import { WSS_MESSAGE_TYPES } from "@/helpers/constants";
import { scrollToTheBottom } from "@/helpers/DOMHelper";

export default {
  name: "TableMessages",
  mixins: [ChatMixin],
  components: {
    "chat-input": ChatInput
  },
  data() {
    return {
      action: "socket/sendToTable"
    };
  },
  methods: {
    /**
     * Send message to group
     */
    sendMessage() {
      if (!this.canSendMessage) {
        return;
      }
      this.$store.dispatch("chat/sendMessage", {
        message: {
          text: this.message,
          type: WSS_MESSAGE_TYPES.TABLE_MESSAGE
        }
      });

      this.message = "";
    }
  },
  computed: {
    ...mapGetters({
      messages: "chat/tableMessages",
      group: "tables/userTable",
      groupTerminology: "room/groupTerminology"
    })
  },
  watch: {
    messages: function() {
      scrollToTheBottom(`group-${this.group.uuid}-messages`);
    }
  }
};
</script>
